<template>
	<nav
		:class="[
			'nav-box',
			{
				'nav-box--small': !isWidthOverlimit,
			},
		]"
	>
		<ul class="nav-box__nav1">
			<li
				v-for="(nav1Item, nav1ItemIdx) in nav"
				:key="`${nav1Item.name}${nav1ItemIdx}`"
				class="nav-box__nav1__item"
			>
				<button
					:class="[
						'nav-box__nav1__btn',
						{
							'nav-box__nav1__btn--selected':
								nav1ItemIdx === nav1Open,
						},
					]"
					@click="toggleNav1(nav1ItemIdx)"
				>
					{{ nav1Item.name }}
				</button>
				<div
					v-if="nav1Item.children && nav1ItemIdx === nav1Open"
					class="nav-box__nav2-bundle"
				>
					<ul
						v-for="(nav2, nav2Idx) in nav1Item.children"
						:key="`${nav1ItemIdx}${nav2Idx}`"
						class="nav-box__nav2"
					>
						<li
							v-for="(nav2Item, nav2ItemIdx) in nav2"
							:key="`${nav2Item.name}${nav2ItemIdx}`"
							class="nav-box__nav2__item"
						>
							<a
								v-if="nav2Item.path"
								:href="getUrl(nav2Item)"
								:class="[
									'nav-box__nav2__btn',
									{
										'has-sub': nav2Item.children,
									},
								]"
								@click.prevent.self="linkToAdmin(nav2Item)"
								>{{ nav2Item.name }}</a
							>
							<button
								v-else
								:class="[
									'nav-box__nav2__btn',
									{
										'has-sub': nav2Item.children,
									},
								]"
							>
								{{ nav2Item.name }}
							</button>
							<div
								v-if="nav2Item.children"
								class="nav-box__nav3-bundle"
							>
								<ul
									v-for="(nav3, nav3Idx) in nav2Item.children"
									:key="`${nav1ItemIdx}${nav2Idx}${nav3Idx}`"
									class="nav-box__nav3"
								>
									<template
										v-for="(nav3Item, nav3ItemIdx) in nav3"
									>
										<li
											v-if="typeModel[nav3Item.type]"
											:key="`${nav3Item.name}${nav3ItemIdx}`"
											class="nav-box__nav3__item"
										>
											<a
												:href="getUrl(nav3Item)"
												class="nav-box__nav3__btn"
												@click.prevent.self="
													linkToAdmin(nav3Item)
												"
												>{{ nav3Item.name }}</a
											>
										</li>
									</template>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</li>
			<li class="nav-box__nav1__item">
				<button
					v-if="!isWidthOverlimit"
					class="nav-box__nav1__btn"
					@click="logout"
				>
					로그아웃
				</button>
			</li>
		</ul>
	</nav>
</template>
<script>
	import { mapState } from 'vuex';
	import Util from '@/util';

	export default {
		name: 'NavBox',
		props: {
			isWidthOverlimit: {
				type: Boolean,
				default: true,
			},
			nav1Open: {
				type: [Boolean, Number],
				default: false,
			},
		},
		computed: {
			...mapState(['nav', 'typeModel']),
		},
		methods: {
			logout() {
				this.$emit('logout');
			},
			toggleNav1(idx) {
				this.$emit('toggleNav1', idx);
			},
			linkToAdmin(item) {
				if (!item.path) return;
				this.$router.push(item.path);
			},
			getUrl(item) {
				return Util.getUrl(item);
			},
		},
	};
</script>
<style lang="scss" scoped>
	NAV.nav-box {
		font-size: 1rem;
		font-weight: 400;

		.nav-box__nav1:after {
			content: '';
			display: block;
			clear: both;
		}

		.nav-box__nav1__item {
			position: relative;
			float: left;
		}

		.nav-box__nav1__btn {
			height: 100%;
			padding: 0 12px;
			line-height: 56px;
			color: #e3eaf6;
		}

		.nav-box__nav1__btn--selected {
			@extend .nav-box__nav1__btn;

			background-color: #262b3a;
			color: #fff;
			font-weight: 700;
		}

		.nav-box__nav2-bundle {
			position: absolute;
			top: 100%;
			left: 0;
			white-space: nowrap;
		}

		.nav-box__nav2 + .nav-box__nav2 {
			border-top: solid 1px #fff;
		}

		.nav-box__nav3 + .nav-box__nav3 {
			border-top: solid 1px #3a4259;
		}

		.nav-box__nav2__item {
			position: relative;

			&:hover {
				.nav-box__nav3-bundle {
					display: block;
				}
			}
		}

		.nav-box__nav2:last-child
			.nav-box__nav2__item:last-child
			.nav-box__nav2__btn {
			border-bottom-left-radius: 4px;
			border-bottom-right-radius: 4px;
		}

		.nav-box__nav2__btn,
		.nav-box__nav3__btn {
			display: block;
			width: 100%;
			padding: 7px 15px;
			color: #fff;
			background-color: #262b3a;
			text-align: left;

			&:hover {
				background-color: $btn-red;
				font-weight: 700;
			}

			&.has-sub {
				position: relative;
				padding-right: 26px;

				&:after {
					content: '';
					position: absolute;
					display: block;
					top: 50%;
					right: 10px;
					width: 6px;
					height: 6px;
					margin-top: -3px;
					border: solid 3px transparent;
					border-bottom: solid 4px #d1d5e6;
					border-top: 0;
					pointer-events: none;
					transform: rotate(90deg);
				}
			}
		}

		.nav-box__nav3-bundle {
			display: none;
			position: absolute;
			top: 0;
			left: 100%;
			padding-left: 4px;
		}

		.nav-box__nav3:first-child
			.nav-box__nav3__item:first-child
			.nav-box__nav3__btn {
			border-top-left-radius: 4px;
			border-top-right-radius: 4px;
		}

		.nav-box__nav3:last-child
			.nav-box__nav3__item:last-child
			.nav-box__nav3__btn {
			border-bottom-left-radius: 4px;
			border-bottom-right-radius: 4px;
		}
	}

	NAV.nav-box--small {
		@extend .nav-box;

		position: absolute;
		width: 100%;
		left: 0;
		top: 100%;
		max-height: 342px;
		overflow-y: auto;

		.nav-box__nav1__item {
			width: 100%;
		}

		.nav-box__nav1__btn {
			width: 100%;
			height: auto;
			background-color: #495470;
			text-align: left;
			padding: 12px 20px;
			line-height: 1;
		}

		.nav-box__nav2-bundle {
			position: static;
		}

		.nav-box__nav2__btn {
			padding-left: 30px;
		}

		.nav-box__nav2__btn,
		.nav-box__nav3__btn {
			border-radius: 0 !important;
		}

		.nav-box__nav3-bundle {
			position: static;
			padding: 0;
		}

		.nav-box__nav3__btn {
			padding-left: 40px;
		}
	}
</style>
